import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Contabilidad.css";

const Contabilidad = () => {
  const [transactions, setTransactions] = useState([]);
  const [filtroTipo, setFiltroTipo] = useState("Todos");
  const [filtroFecha, setFiltroFecha] = useState("Todos");
  const [filtroPagado, setFiltroPagado] = useState("Todos");
  const [filtroBusqueda, setFiltroBusqueda] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [nuevaTransaccion, setNuevaTransaccion] = useState({
    tipo: "Venta",
    descripcion: "",
    preciototal: 0,
    clienteproveedor: "",
    fecha: new Date().toLocaleString('en-US', { timeZone: 'America/Bogota' }).slice(0, 16),
    pagado: "No",
    abono: 0,
    deuda: 0,
    numeroremision: "",
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [editingTransaction, setEditingTransaction] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [historialModalOpen, setHistorialModalOpen] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const [transaccionesPorPagina] = useState(15);

  const userName = localStorage.getItem("username");

  useEffect(() => {
    fetchTransacciones();
    fetchClientes();
  }, []);

  const fetchTransacciones = async () => {
    try {
      const response = await axios.get("https://backend-vbfh.onrender.com/api/contabilidad");
      setTransactions(response.data);
    } catch (error) {
      console.error("Error al obtener transacciones:", error);
    }
  };

  const fetchClientes = async () => {
    try {
      const response = await axios.get("https://backend-vbfh.onrender.com/api/clientes");
      setClientes(response.data);
    } catch (error) {
      console.error("Error al obtener clientes:", error);
    }
  };

  const fetchHistorial = async (transaccionId) => {
    try {
      const response = await axios.get(`https://backend-vbfh.onrender.com/api/contabilidad/historial/${transaccionId}`);
      setHistorial(response.data);
      setHistorialModalOpen(true);
    } catch (error) {
      console.error("Error al obtener el historial:", error);
    }
  };

  const handleFilterTipoChange = (event) => {
    setFiltroTipo(event.target.value);
    setPaginaActual(1);
  };

  const handleFilterFechaChange = (event) => {
    setFiltroFecha(event.target.value);
    setPaginaActual(1);
  };

  const handleFilterPagadoChange = (event) => {
    setFiltroPagado(event.target.value);
    setPaginaActual(1);
  };

  const handleFilterBusquedaChange = (event) => {
    setFiltroBusqueda(event.target.value);
    setPaginaActual(1);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setNuevaTransaccion((prev) => {
      const updatedTransaccion = { ...prev, [name]: value };

      if (name === "pagado") {
        if (value === "Sí") {
          updatedTransaccion.abono = updatedTransaccion.preciototal;
          updatedTransaccion.deuda = 0;
        } else if (value === "No") {
          updatedTransaccion.abono = 0;
          updatedTransaccion.deuda = updatedTransaccion.preciototal;
        }
      } else if (name === "preciototal") {
        updatedTransaccion.deuda = value - (updatedTransaccion.abono ?? 0);
      } else if (name === "abono") {
        updatedTransaccion.deuda = updatedTransaccion.preciototal - value;
      }

      return updatedTransaccion;
    });
  };

  const handleAddTransaction = async () => {
    try {
      const fechaLocal = new Date(nuevaTransaccion.fecha).toISOString();
      await axios.post("https://backend-vbfh.onrender.com/api/contabilidad", {
        ...nuevaTransaccion,
        fecha: fechaLocal,
      });
      fetchTransacciones();
      setModalOpen(false);
      setNuevaTransaccion({
        tipo: "Venta",
        descripcion: "",
        preciototal: 0,
        clienteproveedor: "",
        fecha: new Date().toLocaleString('en-US', { timeZone: 'America/Bogota' }).slice(0, 16),
        pagado: "No",
        abono: 0,
        deuda: 0,
        numeroremision: "",
      });
    } catch (error) {
      console.error("Error al crear transacción:", error);
    }
  };

  const handleEditTransaction = async () => {
    try {
      const total = parseFloat(editingTransaction.preciototal) ?? 0;
      const abono = parseFloat(editingTransaction.abono) ?? 0;
      editingTransaction.deuda = total - abono;
      editingTransaction.usuario = userName;
      await axios.put(`https://backend-vbfh.onrender.com/api/contabilidad/${editingTransaction.id}`, editingTransaction);
      fetchTransacciones();
      setEditingTransaction(null);
    } catch (error) {
      console.error("Error al actualizar transacción:", error);
    }
  };

  const handleDeleteTransaction = async (id) => {
    try {
      await axios.delete(`https://backend-vbfh.onrender.com/api/contabilidad/${id}`);
      fetchTransacciones();
    } catch (error) {
      console.error("Error al eliminar transacción:", error);
    }
  };

  const handleEditClick = (transaccion) => {
    setEditingTransaction({
      ...transaccion,
      fecha: new Date(transaccion.fecha).toLocaleString('en-US', { timeZone: 'America/Bogota' }).slice(0, 16),
    });
  };

  const handleHistorialClick = (transaccion) => {
    fetchHistorial(transaccion.id);
  };

  const toggleRowExpansion = (id) => {
    if (expandedRows.includes(id)) {
      setExpandedRows(expandedRows.filter((rowId) => rowId !== id));
    } else {
      setExpandedRows([...expandedRows, id]);
    }
  };

  const filteredTransactions = transactions.filter((transaccion) => {
    const cumpleTipo = filtroTipo === "Todos" || transaccion.tipo === filtroTipo;
    const cumplePagado =
      filtroPagado === "Todos" ||
      (filtroPagado === "Sí" && transaccion.pagado === "Sí") ||
      (filtroPagado === "No" && (transaccion.pagado === "No" || transaccion.pagado === "Parcial"));
    const cumpleBusqueda =
      (transaccion.clienteproveedor && transaccion.clienteproveedor.toLowerCase().includes(filtroBusqueda.toLowerCase())) ||
      (transaccion.numeroremision && transaccion.numeroremision.toLowerCase().includes(filtroBusqueda.toLowerCase()));

    const fechaTransaccion = new Date(transaccion.fecha);

    if (filtroFecha === "Hoy") {
      const hoy = new Date();
      return cumpleTipo && cumplePagado && cumpleBusqueda && fechaTransaccion.toDateString() === hoy.toDateString();
    } else if (filtroFecha === "Este mes") {
      const hoy = new Date();
      return cumpleTipo && cumplePagado && cumpleBusqueda && fechaTransaccion.getMonth() === hoy.getMonth() && fechaTransaccion.getFullYear() === hoy.getFullYear();
    } else if (filtroFecha === "Rango" && fechaInicio && fechaFin) {
      const inicio = new Date(fechaInicio);
      const fin = new Date(fechaFin);
      return cumpleTipo && cumplePagado && cumpleBusqueda && fechaTransaccion >= inicio && fechaTransaccion <= fin;
    } else {
      return cumpleTipo && cumplePagado && cumpleBusqueda;
    }
  });

  const transaccionesOrdenadas = [...filteredTransactions].sort((a, b) => new Date(b.fecha) - new Date(a.fecha));

  // Lógica de paginación
  const indexUltimaTransaccion = paginaActual * transaccionesPorPagina;
  const indexPrimeraTransaccion = indexUltimaTransaccion - transaccionesPorPagina;
  const transaccionesActuales = transaccionesOrdenadas.slice(indexPrimeraTransaccion, indexUltimaTransaccion);
  const totalPaginas = Math.ceil(transaccionesOrdenadas.length / transaccionesPorPagina);

  const cambiarPagina = (numeroPagina) => {
    setPaginaActual(numeroPagina);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const paginaSiguiente = () => {
    if (paginaActual < totalPaginas) {
      setPaginaActual(paginaActual + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const paginaAnterior = () => {
    if (paginaActual > 1) {
      setPaginaActual(paginaActual - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // Generar números de página para mostrar
  const numerosPagina = [];
  const paginasAMostrar = 5;
  
  let inicioPaginas = Math.max(1, paginaActual - Math.floor(paginasAMostrar / 2));
  let finPaginas = Math.min(totalPaginas, inicioPaginas + paginasAMostrar - 1);
  
  if (finPaginas - inicioPaginas + 1 < paginasAMostrar) {
    inicioPaginas = Math.max(1, finPaginas - paginasAMostrar + 1);
  }
  
  for (let i = inicioPaginas; i <= finPaginas; i++) {
    numerosPagina.push(i);
  }

  const totalVentas = transaccionesOrdenadas
    .filter((t) => t.tipo === "Venta")
    .reduce((acc, t) => acc + (parseFloat(t.preciototal) ?? 0), 0);

  const totalCompras = transaccionesOrdenadas
    .filter((t) => t.tipo === "Compra")
    .reduce((acc, t) => acc + (parseFloat(t.preciototal) ?? 0), 0);

  const totalDeudasClientes = transaccionesOrdenadas
    .filter((t) => t.tipo === "Venta" && (t.pagado === "No" || t.pagado === "Parcial"))
    .reduce((acc, t) => acc + (parseFloat(t.deuda) ?? 0), 0);

  const totalDeudasProveedores = transaccionesOrdenadas
    .filter((t) => t.tipo === "Compra" && (t.pagado === "No" || t.pagado === "Parcial"))
    .reduce((acc, t) => acc + (parseFloat(t.deuda) ?? 0), 0);

  const totalPagosTrabajadores = transaccionesOrdenadas
    .filter((t) => t.tipo === "PagoTrabajador")
    .reduce((acc, t) => acc + (parseFloat(t.preciototal) ?? 0), 0);

const formatCurrency = (value) => {
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value).replace(/\s/g, '');
};

  const generarHTMLParaImprimir = (transaccionesFiltradas) => {
    let titulo = "Tabla Filtrada";
    if (filtroPagado === "Sí") {
      titulo = "Tabla de Pagados";
    } else if (filtroPagado === "No") {
      titulo = "Tabla de No Pagados";
    } else if (filtroTipo === "Venta") {
      titulo = "Tabla de Ventas";
    } else if (filtroTipo === "Compra") {
      titulo = "Tabla de Compras";
    } else if (filtroTipo === "PagoTrabajador") {
      titulo = "Tabla de Pagos a Trabajadores";
    }

    const html = `
      <html>
        <head>
          <title>${titulo}</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }
            h1 {
              text-align: center;
              color: #333;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
            }
            th {
              background-color: #f2f2f2;
              color: #333;
              font-weight: bold;
            }
            tr:nth-child(even) {
              background-color: #f9f9f9;
            }
            tr:hover {
              background-color: #f1f1f1;
            }
            .total-row {
              background-color: #e0e0e0;
              font-weight: bold;
            }
          </style>
        </head>
        <body>
          <h1>${titulo}</h1>
          <table>
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Precio Total</th>
                <th>Cliente/Proveedor</th>
                <th>Fecha</th>
                <th>Pagado</th>
                <th>Abono</th>
                <th>Deuda</th>
                <th>Número de Remisión</th>
              </tr>
            </thead>
            <tbody>
              ${transaccionesFiltradas
                .map(
                  (transaccion) => `
                <tr>
                  <td>${transaccion.tipo}</td>
                  <td>${formatCurrency(transaccion.preciototal ?? 0)}</td>
                  <td>${transaccion.clienteproveedor}</td>
                  <td>${new Date(transaccion.fecha).toLocaleDateString()}</td>
                  <td>${transaccion.pagado}</td>
                  <td>${formatCurrency(transaccion.abono ?? 0)}</td>
                  <td>${formatCurrency(transaccion.deuda ?? 0)}</td>
                  <td>${transaccion.numeroremision}</td>
                </tr>
              `
                )
                .join("")}
            </tbody>
          </table>
        </body>
      </html>
    `;
    return html;
  };

  const imprimirTablaFiltrada = () => {
    const ventanaImpresion = window.open("", "_blank");
    const html = generarHTMLParaImprimir(transaccionesOrdenadas);
    ventanaImpresion.document.write(html);
    ventanaImpresion.document.close();
    ventanaImpresion.print();
  };

  return (
    <div className="comisiones-container">
      <h1>📊 Panel de Contabilidad</h1>

      <div className="resumen-comisiones">
        <div className="resumen-card">
          <h3>Total Ventas</h3>
          <p>{formatCurrency(totalVentas)}</p>
        </div>
        <div className="resumen-card">
          <h3>Total Compras</h3>
          <p>{formatCurrency(totalCompras)}</p>
        </div>
        <div className="resumen-card">
          <h3>Deudas de Clientes</h3>
          <p>{formatCurrency(totalDeudasClientes)}</p>
        </div>
        <div className="resumen-card">
          <h3>Deudas con Proveedores</h3>
          <p>{formatCurrency(totalDeudasProveedores)}</p>
        </div>
        <div className="resumen-card">
          <h3>Pagos a Trabajadores</h3>
          <p>{formatCurrency(totalPagosTrabajadores)}</p>
        </div>
      </div>

      <div className="filtros-comisiones">
        <div className="filtro-group">
          <label>Filtrar por tipo:</label>
          <select value={filtroTipo} onChange={handleFilterTipoChange}>
            <option value="Todos">Todos</option>
            <option value="Venta">Ventas</option>
            <option value="Compra">Compras</option>
            <option value="PagoTrabajador">Pagos a Trabajadores</option>
          </select>
        </div>
        <div className="filtro-group">
          <label>Filtrar por fecha:</label>
          <select value={filtroFecha} onChange={handleFilterFechaChange}>
            <option value="Todos">Todos</option>
            <option value="Hoy">Hoy</option>
            <option value="Este mes">Este mes</option>
            <option value="Rango">Rango de fechas</option>
          </select>
        </div>
        {filtroFecha === "Rango" && (
          <div className="rango-fechas">
            <input
              type="date"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
            />
            <input
              type="date"
              value={fechaFin}
              onChange={(e) => setFechaFin(e.target.value)}
            />
          </div>
        )}
        <div className="filtro-group">
          <label>Filtrar por pago:</label>
          <select value={filtroPagado} onChange={handleFilterPagadoChange}>
            <option value="Todos">Todos</option>
            <option value="Sí">Pagado</option>
            <option value="No">No Pagado</option>
            <option value="Parcial">Parcial</option>
          </select>
        </div>
        <div className="filtro-group">
          <label>Buscar por cliente o remisión:</label>
          <input
            type="text"
            value={filtroBusqueda}
            onChange={handleFilterBusquedaChange}
            placeholder="Cliente o número de remisión"
          />
        </div>
        <button className="btn-refresh" onClick={() => setModalOpen(true)}>
          ➕ Añadir Transacción
        </button>
        <button className="btn-limpiar" onClick={imprimirTablaFiltrada}>
          🖨️ Imprimir Tabla
        </button>
      </div>

      {/* Información de paginación */}
      <div className="info-paginacion-contabilidad">
        <p>
          Mostrando {transaccionesActuales.length} de {transaccionesOrdenadas.length} transacciones 
          (Página {paginaActual} de {totalPaginas})
        </p>
      </div>

      <table className="comisiones-table">
        <thead>
          <tr>
            <th>Tipo</th>
            <th>Descripción</th>
            <th>Precio Total</th>
            <th>Cliente/Proveedor</th>
            <th>Fecha</th>
            <th>Pagado</th>
            <th>Abono</th>
            <th>Deuda</th>
            <th>Número de Remisión</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {transaccionesActuales.map((transaccion) => (
            <React.Fragment key={transaccion.id}>
              <tr onClick={() => toggleRowExpansion(transaccion.id)} className="clickable-row">
                <td>{transaccion.tipo}</td>
                <td>
                  {transaccion.descripcion.length > 30
                    ? `${transaccion.descripcion.slice(0, 30)}...`
                    : transaccion.descripcion}
                </td>
                <td>{formatCurrency(transaccion.preciototal ?? 0)}</td>
                <td>{transaccion.clienteproveedor}</td>
                <td>{new Date(transaccion.fecha).toLocaleDateString()}</td>
                <td>{transaccion.pagado}</td>
                <td>{formatCurrency(transaccion.abono ?? 0)}</td>
                <td>{formatCurrency(transaccion.deuda ?? 0)}</td>
                <td>{transaccion.numeroremision}</td>
                <td>
                  <button className="edit-button" onClick={(e) => { e.stopPropagation(); handleEditClick(transaccion); }}>Editar</button>
                  <button className="delete-button" onClick={(e) => { e.stopPropagation(); handleDeleteTransaction(transaccion.id); }}>Eliminar</button>
                  <button className="historial-button" onClick={(e) => { e.stopPropagation(); handleHistorialClick(transaccion); }}>Historial</button>
                </td>
              </tr>
              {expandedRows.includes(transaccion.id) && (
                <tr className="expanded-row">
                  <td colSpan="10">
                    <div className="expanded-content">
                      <p><strong>Descripción completa:</strong> {transaccion.descripcion}</p>
                      <p><strong>Fecha completa:</strong> {new Date(transaccion.fecha).toLocaleString()}</p>
                      <p><strong>Cliente/Proveedor:</strong> {transaccion.clienteproveedor}</p>
                      <p><strong>Número de Remisión:</strong> {transaccion.numeroremision}</p>
                      <p><strong>Abono:</strong> {formatCurrency(transaccion.abono ?? 0)}</p>
                      <p><strong>Deuda:</strong> {formatCurrency(transaccion.deuda ?? 0)}</p>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      {/* Paginación */}
      {totalPaginas > 1 && (
        <div className="paginacion-container">
          <button 
            className={`boton-paginacion ${paginaActual === 1 ? 'boton-deshabilitado' : ''}`}
            onClick={paginaAnterior}
            disabled={paginaActual === 1}
          >
            ‹ Anterior
          </button>
          
          {/* Mostrar primera página si no está en el rango */}
          {inicioPaginas > 1 && (
            <>
              <button 
                className={`numero-pagina ${1 === paginaActual ? 'pagina-actual' : ''}`}
                onClick={() => cambiarPagina(1)}
              >
                1
              </button>
              {inicioPaginas > 2 && <span className="puntos-suspensivos">...</span>}
            </>
          )}

          {/* Números de página */}
          {numerosPagina.map(numero => (
            <button
              key={numero}
              className={`numero-pagina ${numero === paginaActual ? 'pagina-actual' : ''}`}
              onClick={() => cambiarPagina(numero)}
            >
              {numero}
            </button>
          ))}

          {/* Mostrar última página si no está en el rango */}
          {finPaginas < totalPaginas && (
            <>
              {finPaginas < totalPaginas - 1 && <span className="puntos-suspensivos">...</span>}
              <button 
                className={`numero-pagina ${totalPaginas === paginaActual ? 'pagina-actual' : ''}`}
                onClick={() => cambiarPagina(totalPaginas)}
              >
                {totalPaginas}
              </button>
            </>
          )}

          <button 
            className={`boton-paginacion ${paginaActual === totalPaginas ? 'boton-deshabilitado' : ''}`}
            onClick={paginaSiguiente}
            disabled={paginaActual === totalPaginas}
          >
            Siguiente ›
          </button>
        </div>
      )}

      {/* Modal para añadir transacciones */}
      {modalOpen && (
        <div className="contabilidad-modal-overlay">
          <div className="contabilidad-modal-container">
            <div className="contabilidad-modal-header">
              <h2>Añadir Transacción</h2>
            </div>
            <div className="contabilidad-modal-body">
              <div className="contabilidad-modal-form-group">
                <label>Tipo:</label>
                <select name="tipo" value={nuevaTransaccion.tipo} onChange={handleInputChange}>
                  <option value="Venta">Venta</option>
                  <option value="Compra">Compra</option>
                  <option value="PagoTrabajador">Pago a Trabajador</option>
                </select>
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Descripción:</label>
                <input type="text" name="descripcion" value={nuevaTransaccion.descripcion} onChange={handleInputChange} required />
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Precio Total:</label>
                <input type="number" name="preciototal" value={nuevaTransaccion.preciototal} onChange={handleInputChange} required />
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Cliente/Proveedor:</label>
                <select name="clienteproveedor" value={nuevaTransaccion.clienteproveedor} onChange={handleInputChange}>
                  <option value="">Seleccione un cliente</option>
                  {clientes.map((cliente) => (
                    <option key={cliente.id} value={cliente.nombre}>
                      {cliente.nombre}
                    </option>
                  ))}
                </select>
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Fecha:</label>
                <input
                  type="datetime-local"
                  name="fecha"
                  value={nuevaTransaccion.fecha}
                  onChange={handleInputChange}
                />
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Pagado:</label>
                <select name="pagado" value={nuevaTransaccion.pagado} onChange={handleInputChange}>
                  <option value="Sí">Sí</option>
                  <option value="No">No</option>
                  <option value="Parcial">Parcial</option>
                </select>
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Abono:</label>
                <input
                  type="number"
                  name="abono"
                  value={nuevaTransaccion.abono}
                  onChange={handleInputChange}
                  disabled={nuevaTransaccion.pagado === "Sí"}
                />
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Deuda:</label>
                <input type="number" name="deuda" value={nuevaTransaccion.deuda} readOnly />
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Número de Remisión:</label>
                <input type="text" name="numeroremision" value={nuevaTransaccion.numeroremision} onChange={handleInputChange} required />
              </div>
            </div>
            <div className="contabilidad-modal-footer">
              <button 
                className="contabilidad-modal-btn contabilidad-modal-btn-secondary"
                onClick={() => setModalOpen(false)}
              >
                Cancelar
              </button>
              <button 
                className="contabilidad-modal-btn contabilidad-modal-btn-primary"
                onClick={handleAddTransaction}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para editar transacciones */}
      {editingTransaction && (
        <div className="contabilidad-modal-overlay">
          <div className="contabilidad-modal-container">
            <div className="contabilidad-modal-header">
              <h2>Editar Transacción</h2>
            </div>
            <div className="contabilidad-modal-body">
              <div className="contabilidad-modal-form-group">
                <label>Tipo:</label>
                <select
                  name="tipo"
                  value={editingTransaction.tipo}
                  onChange={(e) =>
                    setEditingTransaction({ ...editingTransaction, tipo: e.target.value })
                  }
                >
                  <option value="Venta">Venta</option>
                  <option value="Compra">Compra</option>
                  <option value="PagoTrabajador">Pago a Trabajador</option>
                </select>
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Descripción:</label>
                <input
                  type="text"
                  name="descripcion"
                  value={editingTransaction.descripcion}
                  onChange={(e) =>
                    setEditingTransaction({ ...editingTransaction, descripcion: e.target.value })
                  }
                  required
                />
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Precio Total:</label>
                <input
                  type="number"
                  name="preciototal"
                  value={editingTransaction.preciototal}
                  onChange={(e) =>
                    setEditingTransaction({ ...editingTransaction, preciototal: e.target.value })
                  }
                  required
                />
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Cliente/Proveedor:</label>
                <select
                  name="clienteproveedor"
                  value={editingTransaction.clienteproveedor}
                  onChange={(e) =>
                    setEditingTransaction({ ...editingTransaction, clienteproveedor: e.target.value })
                  }
                >
                  <option value="">Seleccione un cliente</option>
                  {clientes.map((cliente) => (
                    <option key={cliente.id} value={cliente.nombre}>
                      {cliente.nombre}
                    </option>
                  ))}
                </select>
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Fecha:</label>
                <input
                  type="datetime-local"
                  name="fecha"
                  value={editingTransaction.fecha}
                  onChange={(e) =>
                    setEditingTransaction({ ...editingTransaction, fecha: e.target.value })
                  }
                  required
                />
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Pagado:</label>
                <select
                  name="pagado"
                  value={editingTransaction.pagado}
                  onChange={(e) =>
                    setEditingTransaction({ ...editingTransaction, pagado: e.target.value })
                  }
                >
                  <option value="Sí">Sí</option>
                  <option value="No">No</option>
                  <option value="Parcial">Parcial</option>
                </select>
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Abono:</label>
                <input
                  type="number"
                  name="abono"
                  value={editingTransaction.abono}
                  onChange={(e) =>
                    setEditingTransaction({ ...editingTransaction, abono: e.target.value })
                  }
                  disabled={editingTransaction.pagado === "Sí"}
                />
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Deuda:</label>
                <input
                  type="number"
                  name="deuda"
                  value={editingTransaction.deuda}
                  readOnly
                />
              </div>

              <div className="contabilidad-modal-form-group">
                <label>Número de Remisión:</label>
                <input
                  type="text"
                  name="numeroremision"
                  value={editingTransaction.numeroremision}
                  onChange={(e) =>
                    setEditingTransaction({ ...editingTransaction, numeroremision: e.target.value })
                  }
                  required
                />
              </div>
            </div>
            <div className="contabilidad-modal-footer">
              <button 
                className="contabilidad-modal-btn contabilidad-modal-btn-secondary"
                onClick={() => setEditingTransaction(null)}
              >
                Cancelar
              </button>
              <button 
                className="contabilidad-modal-btn contabilidad-modal-btn-primary"
                onClick={handleEditTransaction}
              >
                Guardar Cambios
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para el historial de cambios */}
      {historialModalOpen && (
        <div className="contabilidad-modal-overlay">
          <div className="contabilidad-modal-container historial-modal-container">
            <div className="contabilidad-modal-header">
              <h2>Historial de Cambios</h2>
            </div>
            <div className="contabilidad-modal-body">
              <table className="historial-table">
                <thead>
                  <tr>
                    <th>Usuario</th>
                    <th>Fecha</th>
                    <th>Tipo</th>
                    <th>Descripción</th>
                    <th>Precio Total</th>
                    <th>Cliente/Proveedor</th>
                    <th>Pagado</th>
                    <th>Abono</th>
                    <th>Deuda</th>
                    <th>Número de Remisión</th>
                  </tr>
                </thead>
                <tbody>
                  {historial.map((cambio) => (
                    <tr key={cambio.id}>
                      <td>{cambio.usuario}</td>
                      <td>{new Date(cambio.fecha_cambio).toLocaleString()}</td>
                      <td>{cambio.tipo}</td>
                      <td>{cambio.descripcion}</td>
                      <td>{formatCurrency(cambio.preciototal ?? 0)}</td>
                      <td>{cambio.clienteproveedor}</td>
                      <td>{cambio.pagado}</td>
                      <td>{formatCurrency(cambio.abono ?? 0)}</td>
                      <td>{formatCurrency(cambio.deuda ?? 0)}</td>
                      <td>{cambio.numeroremision}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="contabilidad-modal-footer">
              <button 
                className="contabilidad-modal-btn contabilidad-modal-btn-secondary"
                onClick={() => setHistorialModalOpen(false)}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contabilidad;